// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ListOrgChartEmployeesQueryVariables = Types.Exact<{
  includeInactive: Types.Scalars['Boolean']['input'];
}>;

export type ListOrgChartEmployeesQuery = { __typename?: 'Query' } & {
  listOrgChartEmployees: Array<
    { __typename?: 'OrgChartEmployee' } & Pick<Types.OrgChartEmployee, 'id'> & {
        employee: { __typename?: 'Employee' } & Pick<
          Types.Employee,
          'pictureUrl' | 'status' | 'numberOfDirectReports'
        > & {
            generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
              Types.EmployeeGeneralInformation,
              'preferredFullName' | 'primaryManagerId'
            >;
          };
        currentMainContract: Types.Maybe<
          { __typename?: 'EmployeeContract' } & {
            company: { __typename?: 'Company' } & Pick<Types.Company, 'id' | 'name'> & {
                country: { __typename?: 'Country' } & Pick<Types.Country, 'id' | 'name'>;
                parentCompany: Types.Maybe<
                  { __typename?: 'Company' } & Pick<Types.Company, 'id' | 'name' | 'countryId'>
                >;
                childrenCompanies: Array<{ __typename?: 'Company' } & Pick<Types.Company, 'name'>>;
              };
          }
        >;
        currentPosition: Types.Maybe<
          { __typename?: 'EmployeeJobHistory' } & Pick<Types.EmployeeJobHistory, 'team' | 'level' | 'jobTitle'> & {
              businessUnit: { __typename?: 'BusinessUnit' } & Pick<Types.BusinessUnit, 'id' | 'name'>;
              department: { __typename?: 'Department' } & Pick<Types.Department, 'id' | 'name'>;
            }
        >;
      }
  >;
};

export const ListOrgChartEmployeesDocument = /*#__PURE__*/ gql`
    query ListOrgChartEmployees($includeInactive: Boolean!) {
  listOrgChartEmployees(filter: {includeInactive: $includeInactive}) {
    id
    employee {
      generalInformation {
        preferredFullName
        primaryManagerId
      }
      pictureUrl
      status
      numberOfDirectReports(includeInactive: $includeInactive)
    }
    currentMainContract {
      company {
        id
        name
        country {
          id
          name
        }
        parentCompany {
          id
          name
          countryId
        }
        childrenCompanies {
          name
        }
      }
    }
    currentPosition {
      team
      level
      businessUnit {
        id
        name
      }
      department {
        id
        name
      }
      jobTitle
    }
  }
}
    `;

/**
 * __useListOrgChartEmployeesQuery__
 *
 * To run a query within a React component, call `useListOrgChartEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOrgChartEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOrgChartEmployeesQuery({
 *   variables: {
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useListOrgChartEmployeesQuery(
  baseOptions: Apollo.QueryHookOptions<ListOrgChartEmployeesQuery, ListOrgChartEmployeesQueryVariables> &
    ({ variables: ListOrgChartEmployeesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListOrgChartEmployeesQuery, ListOrgChartEmployeesQueryVariables>(
    ListOrgChartEmployeesDocument,
    options,
  );
}
export function useListOrgChartEmployeesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListOrgChartEmployeesQuery, ListOrgChartEmployeesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListOrgChartEmployeesQuery, ListOrgChartEmployeesQueryVariables>(
    ListOrgChartEmployeesDocument,
    options,
  );
}
// @ts-expect-error
export function useListOrgChartEmployeesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListOrgChartEmployeesQuery, ListOrgChartEmployeesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListOrgChartEmployeesQuery, ListOrgChartEmployeesQueryVariables>;
export function useListOrgChartEmployeesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListOrgChartEmployeesQuery, ListOrgChartEmployeesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListOrgChartEmployeesQuery | undefined, ListOrgChartEmployeesQueryVariables>;
export function useListOrgChartEmployeesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListOrgChartEmployeesQuery, ListOrgChartEmployeesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListOrgChartEmployeesQuery, ListOrgChartEmployeesQueryVariables>(
    ListOrgChartEmployeesDocument,
    options,
  );
}
export type ListOrgChartEmployeesQueryHookResult = ReturnType<typeof useListOrgChartEmployeesQuery>;
export type ListOrgChartEmployeesLazyQueryHookResult = ReturnType<typeof useListOrgChartEmployeesLazyQuery>;
export type ListOrgChartEmployeesSuspenseQueryHookResult = ReturnType<typeof useListOrgChartEmployeesSuspenseQuery>;
